// Source of truth: InputGUI.py :: zeal_options, conversion_options
export const RELIGION_CHAOS_LEVELS = ['High', 'Medium', 'Low'];
export const RELIGION_ZEALS = [
  '1 - Casual Reverence – faith is personal, relaxed, rarely enforced',
  '2 - Gentle Observers – light rituals, little judgment toward outsiders',
  '3 - Friendly Devout – sincere belief, welcoming and open-minded',
  '4 - Quiet Traditionalists – steady practice, prefers familiar customs',
  '5 - Committed Faithful – strong belief, expects members to follow rules',
  '6 - Doctrinal Guardians – protects teachings, resists "corrupting" ideas',
  '7 - Strict Enforcers – heavy social pressure, punishment for disobedience',
  '8 - Zealous Purifiers – hunts heresy, purges "unclean" influences',
  '9 - Holy Extremists – belief justifies violence, purity above mercy',
  '10 - Fanatical Instruments – total devotion; dissent is treason to the divine',
];

export const CONVERT_PRESSURES = [
  '1 - Private Faith – no outreach, belief kept within families and villages',
  '2 - Local Shrines Only – stays regional, grows slowly by tradition',
  '3 - Open Doors – outsiders may join, but no recruitment effort',
  '4 - Polite Witnesses – gentle invitations, leads by example',
  '5 - Active Missionaries – organized preaching and travel',
  '6 - Temple Builders – establishes branches in new settlements and cities',
  '7 - State-Backed Spread – rulers favor it, incentives drive growth',
  '8 - Compulsory Compliance – public conversion expected to avoid consequences',
  '9 - Forced Conversion – conquest and fear convert populations',
  '10 - Sacred Dominion – unstoppable expansion; all lands must submit',
];
